/**
 * The name of the meta connect function exposed in the DOM
 */
export const METACONNECT_FUNCTION_NAME = 'tac';

export const METACONNECT_DOM_SCRIPT_ID = 'tacscript';

/**
 * Basepath where all the metaconnect scripts are hosted
 */
export const METACONNECT_BASE_PATH = 'https://static.metaconnect.saas.amadeus.com/airline/bootstrap/';

/**
 * Name of the event used to trigger the quality tracking
 */
export const EVENT_QUALITY = 'refx_quality';

/**
 * Name of the event used to trigger the conversion tracking
 */
export const EVENT_CONVERSION = 'refx_booking';
